export const heroContent = {
  h1Line1: 'PandabuySpreadsheet',
  h1Line2: 'The Ultimate 2026 Discovery Hub',
  subheadline: 'Discover thousands of curated PandabuySpreadsheet finds, updated daily with verified items, price comparisons, and trending fashion lists — all organized into structured spreadsheets for effortless browsing.',
};

export const trustBadges = [
  { label: 'Updated Daily', icon: 'ri-refresh-line' },
  { label: '10,000+ Curated Items', icon: 'ri-database-2-line' },
  { label: 'Community Verified', icon: 'ri-shield-check-line' },
  { label: 'Beginner Friendly', icon: 'ri-user-heart-line' },
];

export const valueSection = {
  title: 'Why PandabuySpreadsheet?',
  subtitle: 'The fastest way to discover trending fashion items, streetwear, shoes, and accessories sourced from global marketplaces — all organized into structured, searchable spreadsheets.',
  features: [
    { title: 'Structured Spreadsheets', description: 'Every item is organized into clean, filterable spreadsheet tables with consistent formatting across all categories.' },
    { title: 'Price Comparison Tables', description: 'Compare prices across different sellers at a glance, helping you find the best deals without endless manual searching.' },
    { title: 'Quality-Rated Listings', description: 'Community-driven quality ratings help you identify the best items quickly, saving hours of research and guesswork.' },
    { title: 'Weekly Updated Collections', description: 'Fresh finds added every week, with outdated listings removed so you only browse active, available products.' },
  ],
};

export const howItWorks = {
  title: 'How PandabuySpreadsheet Works',
  steps: [
    { number: '01', title: 'Browse Collections', description: 'Explore our organized spreadsheet categories spanning shoes, clothing, accessories, and more — each with curated, verified item listings.' },
    { number: '02', title: 'Compare Items', description: 'Use structured tables with price ranges, quality scores, and popularity metrics to compare items side-by-side before making decisions.' },
    { number: '03', title: 'Click & Discover', description: 'Click through to find detailed product information on the source marketplace, ready for you to purchase with confidence.' },
  ],
};

export const trendingItems = [
  {
    name: 'Nike Shoes Spreadsheet',
    price: '$25 - $85',
    quality: 4.7,
    updated: 'June 28, 2026',
    imageSeq: 'trending-nike-2026',
  },
  {
    name: 'Luxury Bags Spreadsheet',
    price: '$40 - $200',
    quality: 4.5,
    updated: 'June 27, 2026',
    imageSeq: 'trending-bags-2026',
  },
  {
    name: 'Streetwear Essentials List',
    price: '$15 - $60',
    quality: 4.8,
    updated: 'June 26, 2026',
    imageSeq: 'trending-street-2026',
  },
];

export const seoContent = {
  title: 'What Is PandabuySpreadsheet?',
  paragraphs: [
    'PandabuySpreadsheet is a curated product discovery system designed to help fashion enthusiasts, streetwear collectors, and savvy shoppers find the best items without endless manual searching. Instead of scrolling through hundreds of unorganized listings, our structured spreadsheet approach organizes products into clean, filterable tables with consistent categories, price ranges, and quality indicators.',
    'Unlike traditional discovery methods that rely on scattered social media posts or fragmented forum threads, PandabuySpreadsheet centralizes everything into one streamlined hub. Each spreadsheet category — from shoes and hoodies to bags and accessories — is maintained with verified listings, community quality ratings, and regular weekly updates to ensure accuracy. Whether you are hunting for the latest Nike sneaker finds, luxury bag alternatives, or trending streetwear pieces, the PandabuySpreadsheet ecosystem gives you a structured, searchable starting point that saves hours of research.',
  ],
};

export const faqItems = [
  {
    question: 'How often is the PandabuySpreadsheet updated?',
    answer: 'Our spreadsheets are updated daily with new finds and weekly with full category refreshes. We remove outdated or unavailable listings regularly to ensure you always browse active, verified items. Each category spreadsheet shows a "Last Updated" date so you know exactly how fresh the data is.',
  },
  {
    question: 'Are all items on PandabuySpreadsheet verified?',
    answer: 'Items listed in our spreadsheets go through a community verification process. Users report quality scores, availability status, and pricing accuracy. While we strive for accuracy, we recommend checking the latest availability on the source marketplace before making purchasing decisions.',
  },
  {
    question: 'How do I use the PandabuySpreadsheet categories?',
    answer: 'Simply browse our category dropdown menu or click any category button on this page. Each category links to a dedicated spreadsheet on our main hub at kaspreadsheet.com, where you will find structured tables with item names, prices, quality ratings, and direct links to discover more details.',
  },
  {
    question: 'Is PandabuySpreadsheet free to use?',
    answer: 'Yes, the PandabuySpreadsheet hub is completely free to browse. We believe in making curated fashion discovery accessible to everyone. All category spreadsheets are open for browsing without any registration or payment required.',
  },
  {
    question: 'What makes PandabuySpreadsheet different from other discovery tools?',
    answer: 'Unlike social media posts, Reddit threads, or TikTok links that quickly become outdated, PandabuySpreadsheet uses a structured database approach. Every item is organized into consistent spreadsheet formats with price comparisons, quality ratings, and regular updates — creating a reliable, searchable resource that other platforms cannot match.',
  },
];

export const communityReviews = [
  {
    name: 'Marcus J.',
    handle: '@marcusfinds',
    review: 'Finally a spreadsheet hub that actually stays updated. I have saved hours of scrolling through random posts. The quality ratings are a game-changer for finding reliable sellers.',
  },
  {
    name: 'Emily R.',
    handle: '@emily_streetstyle',
    review: 'The shoe category spreadsheet alone is worth bookmarking. Found three pairs of sneakers I had been hunting for weeks, all organized by price range. Cannot recommend enough.',
  },
  {
    name: 'David K.',
    handle: '@davidk_haul',
    review: 'New to the whole spreadsheet discovery thing and this made it so easy. Clear categories, updated weekly, and the community reviews help me avoid bad listings.',
  },
  {
    name: 'Sophie L.',
    handle: '@sophie_luxe',
    review: 'The luxury bags spreadsheet completely changed how I discover alternatives. Structured, filterable, and the quality indicators are surprisingly accurate across the board.',
  },
  {
    name: 'Alex T.',
    handle: '@alextrends',
    review: 'Been using PandabuySpreadsheet for three months now. The weekly updates are consistent, categories keep expanding, and the comparison tables help me make faster decisions.',
  },
  {
    name: 'Lena W.',
    handle: '@lenafashion',
    review: 'Every fashion discovery tool should work like this. Clean spreadsheets, no fluff, just organized data. The streetwear section is incredibly well curated.',
  },
];